import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Location } from '@angular/common';
import { Observable } from 'rxjs';
import { CompartilhadoUsuarioService } from '../services/compartilhado/compartilhado-usuario.service';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(
        private router: Router, 
        private location: Location,
        private compartilhadoUsuarioService: CompartilhadoUsuarioService
     ) {    }

    private canAccessPage(pageCurrent: string, screens: Screen[]): boolean {
        // for (let index = 0; index < screens.length; index++) {
        //     if (pageCurrent.toLowerCase() === screens[index].link.split('/')[0].toLowerCase() ||
        //         pageCurrent.toLowerCase() === 'painel-de-controle') {
        //         return true;
        //     }
        // }

        // return false;

        return true;
    }

    // Só fazer a validação se o usuário tem o token
    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): boolean | Observable<boolean> {

        let user = this.compartilhadoUsuarioService.obterUsuarioLogado()
        if(user == null) {
            this.router.navigate(['/login']);
            return false;
        }

        return true;
    }
}
